import { PageHeader } from 'components/page-components/page-header/page-header';
import { PAGE_NOT_FOUND } from 'constants/test-ids';

export const NotFound = () => {
  return <PageHeader title="Page Not Found" dataTestId={PAGE_NOT_FOUND} />;
};
